import { Header, flexRender, HeaderContext } from '@tanstack/react-table';

import { Flex } from 'shared_DEPRECATED/components/Flex';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';
import Spacer from 'shared_DEPRECATED/components/Spacer';

import { Typography } from 'shared/components/Typography';

type HeaderCellProps<TData extends object> = {
  header: Header<TData, unknown>;
};

export const SessionsTableHeaderCell = <TData extends object>({
  header,
}: HeaderCellProps<TData>) => {
  const canSort = header.column.getCanSort();
  const isSorted = !!header.column.getIsSorted();
  const isSortedDesc = header.column.getIsSorted() === 'desc';

  const activeSortIcon = isSortedDesc ? iconNames.sortDesc : iconNames.sortAsc;

  return (
    <Spacer size="lg">
      <Flex justifyContent="flex-start" dataTestid="sessions-table-header">
        <Typography
          fontWeight="medium"
          type="small"
          whiteSpace="nowrap"
          color="black"
        >
          {flexRender(
            header.column.columnDef.header as
              | string
              | ((props: HeaderContext<TData, unknown>) => any)
              | undefined,
            header.getContext()
          )}
        </Typography>
        {canSort && (
          <Spacer as="span" size="zr zr zr md">
            <Icon name={isSorted ? activeSortIcon : iconNames.sort} />
          </Spacer>
        )}
      </Flex>
    </Spacer>
  );
};
